const visa = require('./visa.png')
const mastercard = require('./mastercard.png')
const amex = require('./amex.png')
const discover = require('./discover.png')
const jcb = require('./jcb.png')
const other = require('./default.png')
const bank = require('./bank.svg')

export default {
    visa,
    mastercard,
    amex,
    'american express': amex,
    jcb,
    discover,
    bank,
    default: other,
}
